import type { Document } from '@contentful/rich-text-types'

const treatYoutubeUrl = (url: string) => {
  if (url.toLowerCase().includes('youtube.com')) {
    const urlObject = new URL(url)
    const videoId = urlObject.pathname.split('/').pop()
    return `https://www.youtube.com/embed/${videoId}?rel=0`
  }

  /**
   * TODO: Add Vimeo support
   */

  return url
}

/**
 *
 * TODO: Support display presenters
 * TODO: Support displaying description
 */
export const VideoFigure = ({
  src,
  title,
}: {
  src: string
  title: string
  description?: Document
}) => (
  <figure className="video">
    <iframe
      loading="lazy"
      src={treatYoutubeUrl(src)}
      title={title}
      allow="autoplay; fullscreen; picture-in-picture"
    />
    {/* {description && <figcaption>{description}</figcaption>} */}
  </figure>
)
